import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'prism-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
})
export class LoadingBarComponent implements OnInit{

  @Input() barWidth: string = '10rem'; // Default width
  @Input() barHeight: string = '0.5rem'; // Default height
  @Input() barBackgroundColor: string = 'var(--color-1)'; // Default height


  constructor(
  ) { }

  ngOnInit(): void {

  }


}
